<dashboard-dialog-frame class="follow-up-editor-dialog" [header]="headerTitle()" [actions]="actions()" [dialogRef]="dialogRef">

	@if(showFollowUpForm() === true) {
	<div class="d-flex flex-column gap-2 p-2">
		<person-finder-widget (selectedRowId)="setSelectedPersonId($event)"
			[selectedPersonName]="values().personName" [hasPersonFieldError]="hasPersonFieldError"
			[disabled]="personSearchDisabled()"></person-finder-widget>

		<common-select-field [field]="externalRoleId()"></common-select-field>

		<common-date-time-field [field]="followUpDate()"></common-date-time-field>

		<staff-selector-widget [disabled]="false" [data]="staffData()" [userId]="app.data().user.userId"
			[value]="{staffId: values().staffId}" (valueChange)="handleStaffValueChange($event)"></staff-selector-widget>

		<common-select-field [field]="staffRoleId()"></common-select-field>

		<common-select-field [field]="purpose()"></common-select-field>

		<common-text-field [field]="notes()"></common-text-field>

	</div>
	}

</dashboard-dialog-frame>